import { ReactedUsersBox } from "./Post.styles";
import { Badge, Stack } from "@mui/material";
import { LatestReactedUserType } from "@shared/types";
import { AvatarOptions } from "../UserAvatar/UserAvatar.types";
import userAvatarChecker from "../../Shared/UserAvatarChecker";
import { UserAvatarFactory } from "../UserAvatar/UserAvatarFactory";
import { GetReactionIcon } from "@shared/Components/Tippspiel/Reactions/ReactionsIconsFactory";

export const PostLatestReactedUsers = ({
    reactedUsers = [],
    onLatestReactedUserClick,
}: {
    reactedUsers: LatestReactedUserType[];
    onLatestReactedUserClick: (
        e: React.MouseEvent<HTMLElement>,
        user: LatestReactedUserType,
    ) => void;
}) => {
    return (
        <Stack
            sx={{
                overflowX: "scroll",
                overflowY: "hidden",
                height: "44px",
            }}
        >
            <ReactedUsersBox>
                {reactedUsers.map((user, key) => {
                    const onClick = (e: React.MouseEvent<HTMLElement>) => {
                        onLatestReactedUserClick(e, user);
                    };
                    const avatarOptions: AvatarOptions = {
                        uuid: user.uuid,
                        avatar: user.avatar,
                        gender: user.gender,
                        onClick: onClick,
                        onError: () =>
                            userAvatarChecker(user.avatar, user.uuid),
                    };

                    return (
                        <Badge
                            key={key}
                            overlap="circular"
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                            }}
                            badgeContent={
                                <GetReactionIcon
                                    reactionName={user.reactionType}
                                />
                            }
                            sx={{
                                "& .MuiAvatar-root > svg": {
                                    width: "100%",
                                    height: "100%",
                                },
                            }}
                        >
                            <UserAvatarFactory {...avatarOptions} />
                        </Badge>
                    );
                })}
            </ReactedUsersBox>
        </Stack>
    );
};
